import { ClipboardCheck, FileSearch, Handshake, Video } from "lucide-react";

const STEPS = [
  {
    icon: Video,
    title: "Reunión virtual inicial",
    description:
      "Conversamos por videollamada para conocer tu situación, tus necesidades y el alcance del servicio.",
  },
  {
    icon: FileSearch,
    title: "Diagnóstico",
    description:
      "Revisamos tu información fiscal y contable para detectar obligaciones, riesgos y oportunidades de mejora.",
  },
  {
    icon: Handshake,
    title: "Propuesta y presupuesto",
    description:
      "Definimos una propuesta de trabajo clara, con el presupuesto correspondiente según el servicio requerido.",
  },
  {
    icon: ClipboardCheck,
    title: "Gestión online continua",
    description:
      "Avanzamos con la gestión digital, recordatorios, presentaciones y planificación fiscal.",
  },
];

export const WorkProcess = () => {
  return (
    <section
      id="como-trabajamos"
      data-testid="work-process-section"
      aria-label="Cómo trabajamos"
      className="bg-cream-300 py-16 md:py-24"
    >
      <div className="container mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-12 text-center md:mb-16">
          <span className="mb-3 inline-block font-poppins text-sm font-medium uppercase tracking-wide text-gold">
            Cómo trabajamos
          </span>
          <h2 className="mb-4 font-poppins text-3xl font-semibold text-navy-900 md:text-4xl lg:text-5xl">
            Un proceso simple y 100% online
          </h2>
          <p className="mx-auto max-w-2xl font-inter text-base text-navy-700 md:text-lg">
            Desde la primera reunión hasta la gestión continua, todo el proceso
            se realiza de forma remota y ordenada.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
          {STEPS.map((step, index) => (
            <article
              key={step.title}
              data-testid={`work-step-${index}`}
              className="rounded-2xl border border-navy-900/5 bg-white p-6 shadow-sm md:p-7"
            >
              <div className="mb-5 flex h-12 w-12 items-center justify-center rounded-xl bg-gold/10">
                <step.icon className="h-6 w-6 text-gold" strokeWidth={1.5} />
              </div>
              <p className="mb-2 font-poppins text-sm font-medium text-gold">
                Paso {index + 1}
              </p>
              <h3 className="mb-3 font-poppins text-lg font-semibold text-navy-900">
                {step.title}
              </h3>
              <p className="font-inter text-sm leading-relaxed text-navy-700">
                {step.description}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
